import React, { useState, createContext } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import HomeCenter from '../pages/homecenter'

// Global Contexts
export const WSContext = createContext([] as any[])
export const WSMinContext = createContext([] as any[])
export const LoginContext = createContext([] as any[])
export const LoginMsgContext = createContext([] as any[])
export const NoLoginMsgContext = createContext([] as any[])

export default function AppRouter() {
  const [login, setLogin] = useState(false)
  const [loginmsg, setloginmsg] = useState({} as any)
  const [nologinmsg, setnologinmsg] = useState({} as any)

  return (
    <WSContext.Provider value={[]}>
      <WSMinContext.Provider value={[]}>
        <LoginContext.Provider value={[login, setLogin]}>
          <LoginMsgContext.Provider value={[loginmsg, setloginmsg]}>
            <NoLoginMsgContext.Provider value={[nologinmsg, setnologinmsg]}>
              <BrowserRouter>
                <Routes>
                  {/* Route to HomeCenter only */}
                  <Route path='/' element={<HomeCenter />} />
                  {/* Redirect all other paths to the home */}
                  <Route path='*' element={<Navigate to='/' />} />
                </Routes>
              </BrowserRouter>
            </NoLoginMsgContext.Provider>
          </LoginMsgContext.Provider>
        </LoginContext.Provider>
      </WSMinContext.Provider>
    </WSContext.Provider>
  )
}
